import { useCallback } from 'react';

/**
 * Hook pour jouer un son de succès agréable
 * Utilise l'API Web Audio pour générer un son de notification
 */
export const useSuccessSound = () => {
  const playSuccessSound = useCallback(() => {
    try {
      // Vérifier si l'API Web Audio est disponible
      if (typeof window === 'undefined' || !window.AudioContext) {
        console.warn('[useSuccessSound] Web Audio API not available');
        return;
      }

      const audioContext = new (window.AudioContext || (window as any).webkitAudioContext)();
      
      // Créer un son de notification agréable (accord majeur)
      const now = audioContext.currentTime;
      const duration = 0.3;
      
      // Jouer 3 notes successives pour créer un accord agréable
      const frequencies = [523.25, 659.25, 783.99]; // Do-Mi-Sol (accord majeur)
      
      frequencies.forEach((freq, index) => {
        const oscillator = audioContext.createOscillator();
        const gainNode = audioContext.createGain();
        
        oscillator.connect(gainNode);
        gainNode.connect(audioContext.destination);
        
        // Type de son: sine wave pour un son doux
        oscillator.type = 'sine';
        oscillator.frequency.setValueAtTime(freq, now);
        
        // Envelope ADSR pour un son naturel
        const startTime = now + (index * 0.05);
        gainNode.gain.setValueAtTime(0, startTime);
        gainNode.gain.linearRampToValueAtTime(0.15, startTime + 0.05); // Attack
        gainNode.gain.linearRampToValueAtTime(0.1, startTime + 0.1); // Decay
        gainNode.gain.setValueAtTime(0.1, startTime + duration - 0.1); // Sustain
        gainNode.gain.linearRampToValueAtTime(0, startTime + duration); // Release
        
        oscillator.start(startTime);
        oscillator.stop(startTime + duration);
      });
      
      // Nettoyer le contexte audio après utilisation
      setTimeout(() => {
        audioContext.close();
      }, (duration + 0.2) * 1000);
      
    } catch (error) {
      console.error('[useSuccessSound] Error playing success sound:', error);
    }
  }, []);
  
  return { playSuccessSound };
};
